import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { DtoLocalStoragePersistence } from "../../localStoragePersistence/common/DtoLocalStoragePersistence";
import { DtoId } from "../../dto/DtoId";
import { EntityDTO } from "../../dto/v4/EntityDTO";

export default function useStateWithLocalStoragePersistenceAndDefault<
  S,
  DTO extends EntityDTO,
>(
  identifier: DtoId,
  fromStateToPersistedMapping: (s: S) => DTO,
  fromPersistedToStateMapping: (p: DTO) => S,
  defaultValue: S | ((identifier: DtoId) => S),
  dtoLocalStoragePersistence: DtoLocalStoragePersistence<DTO>,
): [S, Dispatch<SetStateAction<S>>] {
  const [value, setValue] = useState<S>(() => readPersistence());

  function readPersistence(): S {
    const dto = dtoLocalStoragePersistence.load(identifier).match(
      (v) => v,
      (e) => {
        throw e;
      },
    );
    if (dto) {
      const mappedValue = fromPersistedToStateMapping(dto);
      console.debug("read persisted state from local storage " + identifier, {
        state: mappedValue,
        dto: dto,
      });
      return mappedValue;
    } else {
      return defaultValue instanceof Function
        ? defaultValue(identifier)
        : defaultValue;
    }
  }

  useEffect(() => {
    const persisted = fromStateToPersistedMapping(value);
    dtoLocalStoragePersistence.persist(persisted);
  }, [dtoLocalStoragePersistence, fromStateToPersistedMapping, value]);

  return [value, setValue];
}
